import React, { useRef } from 'react'
import { IconCheck, IconCopy } from '../../../../shared/icon/icon'
import { useCopy } from '../../../../shared/clipboard/clipboard'
import '../../../../shared/sso-workspace/auth-card.scss'

// One copy button per secret, the login-device modal's pattern
// (login-device-modal.js CopyCode): primary, turns to "Copied" for a moment
// -- only after a real copy (shared/clipboard). When the browser refuses,
// the secret is selected and the shortcut named.
const CopySecret = ({ label, value, text }) => {
  const copy = useCopy()
  return (
    <>
      <button type="button" className={`btn sw-btn-primary btn-sm ${copy.copied ? 'is-copied' : ''}`} aria-label={`Copy ${label}`} onClick={() => copy.copy(value, text)}>
        {copy.copied ? <IconCheck /> : <IconCopy />} {copy.copied ? 'Copied' : 'Copy'}
      </button>
      {copy.manual && <span className="sw-hint" role="status">{copy.hint}</span>}
    </>
  )
}

const SecretRow = ({ label, value }) => {
  const text = useRef(null)
  return (
    <div className="ar-row mb-2">
      <span>{label}: <code className="ar-secret" ref={text}>{value}</code></span>
      <CopySecret label={label} value={value} text={text} />
    </div>
  )
}

// A generated secret (a webhook's signing secret), shown once (spec §12.4,
// §20.2). Used by the route editor's inline target and the target drawer.
// The caller blocks leaving until "I've copied it" (onConfirm).
export const SecretPanel = ({ secrets, labelOf = k => k, rotated, onConfirm }) =>
  <div className="sw-notice warn ar-secret-panel" role="status">
    <div>
      <p className="fw-semibold">Copy it now: it won't be shown again.{rotated ? ' The old secret keeps signing for 24 hours.' : ''}</p>
      {Object.entries(secrets).map(([k, v]) => <SecretRow key={k} label={labelOf(k)} value={v} />)}
      <button type="button" className="btn sw-btn btn-sm" onClick={onConfirm}>I've copied it</button>
    </div>
  </div>
